export default "__VITE_ASSET__Cv8J$F61__"